module.exports = __webpack_public_path__ + "static/media/icon_arrow_R_p.196a053a.svg";